import { render } from "./DeletedCategories.vue?vue&type=template&id=4bc60978&scoped=true"
import script from "./DeletedCategories.vue?vue&type=script&lang=js"
export * from "./DeletedCategories.vue?vue&type=script&lang=js"

import "./DeletedCategories.vue?vue&type=style&index=0&id=4bc60978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc60978"]])

export default __exports__